import { branch, renderNothing } from 'recompose'

import Marker from 'shared/components/ShowStreetViewMarker'
import { loadGoogleAPI } from 'map/actions'
import { googleAPIReadySelector } from 'map/selectors'
import { fetchPlaceOfInterests } from 'sfproxy/actions'
import { placeOfInterestSelector } from 'sfproxy/selectors'
import { loadOnMount } from 'shared/hoc'

import DownloadApp from 'shared/components/DownloadApp'
import POIMap from './POIMap'
import POITitle from './POITitle'
import POIDescription from './POIDescription'

const POI = ({ placeOfInterestId, placeOfInterest = {} }) => (
    <div id="car-park" className="car-park content">
        <div className="map">
            <POIMap placeOfInterestId={placeOfInterestId}>
                <Marker name={placeOfInterest.name} type={placeOfInterest.poiType} />
            </POIMap>
        </div>
        <POITitle title={placeOfInterest.name} />
        <POIDescription description={placeOfInterest.description} />
        <DownloadApp />
    </div>
)

export default compose(
    connect(
        createStructuredSelector({
            placeOfInterest: placeOfInterestSelector,
            apiReady: googleAPIReadySelector,
        }),
        { fetchPlaceOfInterests, loadGoogleAPI }
    ),
    loadOnMount('fetchPlaceOfInterests', ({ placeOfInterestId }) => [placeOfInterestId]),
    branch(props => !props.placeOfInterest, renderNothing)
)(POI)
